import { render, staticRenderFns } from "./wallet_list.vue?vue&type=template&id=705a76aa&scoped=true&"
import script from "./wallet_list.vue?vue&type=script&lang=js&"
export * from "./wallet_list.vue?vue&type=script&lang=js&"
import style0 from "./wallet_list.vue?vue&type=style&index=0&id=705a76aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a76aa",
  null
  
)

export default component.exports